export default "__VITE_ASSET__CU5Tsi1Y__"